import { render } from "./psw.vue?vue&type=template&id=552f6797&scoped=true"
import script from "./psw.vue?vue&type=script&lang=js"
export * from "./psw.vue?vue&type=script&lang=js"

import "./psw.vue?vue&type=style&index=0&id=552f6797&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552f6797"]])

export default __exports__